import _ = require("underscore");

const attrname = "_extensions_";
let extensionIndex = 0;

function isExtended(o: any) {
    return typeof o[attrname] === "number";
}

class Extensions {
    private extensions = [];

    /**
    Get the extension lookup identifier for this object
    @param o the object of interest
    @param [force=true] if true, forces the identifier to exist
    */ 
    getExtensionKey(o: any, force = true) {
        (force && !o[attrname] && this.extend(o));
        return o[attrname];
    }

    /**
    Forces the existence of an extension container for an object
    @param o the object of interest
    @param [ext] sets these value on the extension object
    */ 
    extend<T,U>(o: T, ext?: U) {
        let key = o[attrname];
        if (typeof key === "undefined") {
            key = ++extensionIndex;
            o[attrname] = key;
        }

        // ensure the extension object exists
        let extensions = this.extensions[key] = this.extensions[key] || {};

        // update the extension values
        if (ext) {
            _.keys(ext).forEach(k => extensions[k] = ext[k]);
        }

        return <T&U>extensions;
    }

    /**
    Ensures extensions are shared across objects
    */
    bind(o1: any, o2: any) {
        if (isExtended(o1)) {
            if (isExtended(o2)) {
                if (o1[attrname] !== o2[attrname]) throw "both objects already bound";
            } else {
                o2[attrname] = o1[attrname];
            }
        } else {
            if (isExtended(o2)) {
                o1[attrname] = o2[attrname];
            } else {
                o2[attrname] = this.getExtensionKey(o1, true);
            }
        }
    }

}
 
export = Extensions;